/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonRelationship/view.blocks to change it.
import ChoiceList from 'DesignSystem/ChoiceList/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonRelationship({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePersonRelationship",
  focusArea,
  choices,
  onClick,
  value
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="ResponsiblePersonRelationship.Vertical"
  data-view-path={viewPath}
 ref={focusArea}
 style={{'--o-1-fTonu': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResponsiblePersonRelationship.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text="What is the relationship of the responsible person to the patient?"
/>
</div>
<ChoiceList
  viewPath={`${viewPath}/ChoiceList`}
 from={choices}
 onClick={onClick}
 selected={value}
/>
</div>
{children}
</React.Fragment>)
}